<template>
  <div class="bb-notifications-window-hr">
    <i
      class="icon-cross bb-notifications-window-hr__icon"
      @click.stop="onDelete"
    />
    <div v-html="item.notificationStatus.icon()"/>
    <div class="bb-notifications-window-hr-right">
      <div class="bb-notifications-window-hr__title">
        {{item.notificationStatus.name}}
      </div>
      <div class="bb-notifications-window-hr__description">
        {{ createDescription }}
      </div>
      <div
        v-if="item.rejectComment"
        class="bb-notifications-window-hr-reject"
      >
        <div class="bb-notifications-window-hr__description bb-notifications-window-hr__description_bold">
          Reason
        </div>
        <div class="bb-notifications-window-hr__description">
          {{item.rejectComment}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import {NOTIFICATION_USER_HR_ID} from '@/constants/userTypeNotification'

export default {
  name: 'NotificationsWindowHr',
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    createDescription () {
      const { firstName, lastName, eventType, notificationStatus, startDate, userType } = this.item
      const { name } = eventType
      const { desc, descFirst } = notificationStatus
      const date = moment(startDate).format('MMM D, YYYY')
      const time = moment(startDate).format('h:mm a')
      const textHr = `${firstName} ${lastName} ${desc} ${name} on`
      const textEmployee = `${descFirst} ${name} ${desc}`
      const text = userType !== NOTIFICATION_USER_HR_ID ? textHr : textEmployee
      return `${text} ${date} at ${time}`
    }
  },
  methods: {
    onDelete () {
      this.$emit('onDelete', this.index)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";

  .bb-notifications-window-hr {
    display: grid;
    grid-template-columns: 36px 1fr;
    grid-gap: 0 16px;
    width: 292px;
    min-height: 79px;
    padding: 16px 18px 16px 18px;
    border-radius: 4px;
    background: $color-white;
    box-shadow: 0 0 20px rgba($color-black, 0.07);
    position: relative;

    &__icon {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 26px;
      height: 24px;
      font-size: 12px;
      color: $color-silver-deep;
      cursor: pointer;
      transition: 0.3s;

      &:before {
        margin: 0;
      }

      &:hover {
        color: $color-dusty-gray
      }
    }

    &__title {
      font-size: 13px;
      font-weight: 500;
      line-height: 16px;
    }

    &__description {
      font-size: 11px;
      font-weight: 300;
      line-height: 13px;

      &:first-letter {
        text-transform: capitalize;
      }

      &_bold {
        font-weight: 500;
      }
    }
  }

.bb-notifications-hr-item-right {
  display: grid;
  grid-gap: 7px 0;
}

.bb-notifications-hr-item-reject {
  display: grid;
  grid-gap: 7px 0;
  margin: 5px 0 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Notifications/NotificationsWindow/NotificationsWindowHr.vue